export default __webpack_public_path__ + "static/media/title.f9e52960.svg";